import React from "react"

function Footer() {
  return (
    <footer style={footerContainerStyles}>
      <div className="container text-center p-1">
        <h4 style={textStyles}>
          Copyright © NStF Blogs {new Date().getFullYear()}
        </h4>
      </div>
    </footer>
  )
}

export default Footer

const footerContainerStyles = {
  paddingTop: "5px",
  backgroundColor: "#121212",
  color: "#ffffff",
}

const textStyles = {
  fontFamily: `"Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande", "Lucida Sans", "Arial", "sans-serif"`,
  fontSize: "16px",
  fontWeight: 500,
}
